export const TIME_INTERVAL_OPTIONS = [
    { value: '1', title: '1 day' },
    { value: '2', title: '2 days' },
    { value: '5', title: '5 days' },
    { value: '7', title: '7 days' },
    { value: '10', title: '10 days' },
    { value: '30', title: '30 days' },
    { value: '-1', title: 'All time' },
    { value: '-2', title: 'Set interval' },
];

export const LOGS_TIME_INTERVAL_OPTIONS = [
    { value: '1', title: '1 day' },
    { value: '2', title: '2 days' },
    { value: '5', title: '5 days' },
    { value: '10', title: '10 days' },
    { value: '-2', title: 'Set interval' },
];

export const TEST_CASES_TARGET_BUILDS_SUMMARY_TARGET_BUILDS_PER_PAGE = 10;
export const TEST_CASES_TARGET_BUILDS_SUMMARY_TEST_CASES_PER_PAGE = 75;

export const TARGET_BUILDS_PLATFORMS_SUMMARY_PER_PAGE = 20;

export const TARGET_BUILDS_HISTORY_PER_PAGE = 50;

export const UPLOAD_REQUEST_RESULTS_TARGET_BUILDS_PER_PAGE = 10
export const UPLOAD_REQUEST_RESULTS_DATES_PER_PAGE = 50

export const LOGS_PRODUCTS = [
    'MariaDBEnterprise',
    'MariaDBServerCommunity',
];

export const CI_SERVICES = [
    'BuildBot',
    'Jenkins',
];

export const BUILD_TYPES = {
    MANUAL: { id: 1, title: 'Manual' },
    CHANGES: { id: 2, title: 'Changes' },
    TIMER: { id: 3, title: 'Timer' },
}

export const JIRA_URL = 'https://jira.mariadb.org';
export const JIRA_PROJECTS = [
    { name: 'MDEV', pid: '10000', issueType: '1' },
    { name: 'MENT', pid: '11500', issueType: '1' },
]

export const PARSER_RESULT_CODES = {
    SUCCESS: [1],
    NO_XML: [3],
    FAILURE: [0, 2],
}

export const MAXSCALE_MTR_NAME = 'maxscale-test'

export const AUTH_STATUS = Object.freeze({
    UNKNOWN: "unknown",
    UNAUTHENTICATED: "unauthenticated",
    FORBIDDEN: "forbidden",
    AUTHORIZED: "authorized",
    ERROR: "error"
})
